<template>
    <div class="d-flex align-items-center">
        <svg class="infab-symbol" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80.7 297">
            <path class="st0" d="M80.7 39.3c0 22.1-17.1 39.3-39.3 39.3 -22.1 0-39.3-17.2-39.3-39.3C2.1 17.2 19.3 0 41.4 0 63.6 0 80.7 17.2 80.7 39.3M66.9 276.3c-0.6 7-6.6 14-13.4 15.6l-20.4 4.8c-6.8 1.6-13-2.8-13.7-9.7L0.1 111.3c-0.8-6.9 4.3-11.9 11.2-11l56.8 7.4c6.9 0.9 12.1 7.3 11.5 14.3L66.9 276.3z"/>
        </svg>
        Katalog
    </div>
</template>
<script>
export default {
    name: 'Logo'
}
</script>
<style lang="scss" scoped>
    .infab-symbol {
        margin-right: .8rem;
        height: 2.2rem;
    }
    .st0{fill:#FEEB00;}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Logo.vue